import React, { FC } from 'react';
import * as Styled from './MMediaSelector.styles';
import { MMediaSelectorProps, MMediaSelectorMediaType } from './MMediaSelector.types';
import { MMediaImage } from '../MMediaImage';
import { MMediaCarousel } from '../MMediaCarousel';
import { MCtaThumbnail } from '../MCtaThumbnail';
import { MVideoThumbnail } from '../MVideoThumbnail';
import { MVideoBackground } from '../MVideoBackground';

const COMPONENT_NAME = 'm-web-ui-kit-MMediaSelector';
const TEST_ID = 'web-ui-kit-MMediaSelector';

export const MMediaSelector: FC<MMediaSelectorProps> = ({
  mediaType = MMediaSelectorMediaType.Image,
  mMediaImage,
  mMediaCarousel,
  mCtaThumbnail,
  mVideoThumbnail,
  mVideoBackground,
  className,
  ...rest
}) => {
  const renderMedia = () => {
    switch (mediaType) {
      case MMediaSelectorMediaType.Image:
        return mMediaImage ? <MMediaImage {...mMediaImage} /> : null;
      case MMediaSelectorMediaType.Carousel:
        return mMediaCarousel ? <MMediaCarousel {...mMediaCarousel} /> : null;
      case MMediaSelectorMediaType.ModalVideo:
        return mVideoThumbnail ? <MVideoThumbnail {...mVideoThumbnail} /> : null;
      case MMediaSelectorMediaType.AutoplayVideo:
      // falls through
      case MMediaSelectorMediaType.BackgroundVideo:
        return mVideoBackground ? <MVideoBackground {...mVideoBackground} /> : null;
      case MMediaSelectorMediaType.CTAOverlay:
        return mCtaThumbnail ? <MCtaThumbnail {...mCtaThumbnail} /> : null;
      default:
        return mMediaImage ? <MMediaImage {...mMediaImage} /> : null;
    }
  };

  return (
    <Styled.Wrapper data-component-name={COMPONENT_NAME} data-testid={TEST_ID} className={className} {...rest}>
      {renderMedia()}
    </Styled.Wrapper>
  );
};

export * from './MMediaSelector.types';
